export const REGISTRATION_REQUEST = "REGISTRATION_REQUEST";
export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";
export const REGISTRATION_FAILURE = "REGISTRATION_FAILURE";
export const REGISTRATION_OTP_REQUEST = "REGISTRATION_OTP_REQUEST";
export const REGISTRATION_OTP_SUCCESS = "REGISTRATION_OTP_SUCCESS";
export const REGISTRATION_OTP_FAILURE = "REGISTRATION_OTP_FAILURE";
export const REGISTRATION_OTP_VERIFY = "REGISTRATION_OTP_VERIFY";
export const REGISTRATION_OTP_VERIFY_SUCCESS =
  "REGISTRATION_OTP_VERIFY_SUCCESS";
export const REGISTRATION_OTP_VERIFY_FAILURE =
  "REGISTRATION_OTP_VERIFY_FAILURE";
export const ACTIVATION_GENERIC_LINK_REQUEST =
  "ACTIVATION_GENERIC_LINK_REQUEST";
export const ACTIVATION_GENERIC_LINK_SUCCESS =
  "ACTIVATION_GENERIC_LINK_SUCCESS";
export const ACTIVATION_GENERIC_LINK_FAILURE =
  "ACTIVATION_GENERIC_LINK_FAILURE";
export const ACTIVATION_GENERIC_OTP_VERIFY_REQ =
  "ACTIVATION_GENERIC_OTP_VERIFY_REQ";
export const ACTIVATION_GENERIC_OTP_VERIFY_SUCCESS =
  "ACTIVATION_GENERIC_OTP_VERIFY_SUCCESS";
export const ACTIVATION_GENERIC_OTP_VERIFY_FAILURE =
  "ACTIVATION_GENERIC_OTP_VERIFY_FAILURE";
export const ACTIVATION_PERSONAL_LINK_REQ = "ACTIVATION_PERSONAL_LINK_REQ";
export const ACTIVATION_PERSONAL_LINK_REQ_SUCCESS =
  "ACTIVATION_PERSONAL_LINK_REQ_SUCCESS";
export const ACTIVATION_PERSONAL_LINK_REQ_FAILURE =
  "ACTIVATION_PERSONAL_LINK_REQ_FAILURE";
export const ACTIVATE_PERSONAL_REQ = "ACTIVATE_PERSONAL_REQ";
export const ACTIVATE_PERSONAL_REQ_SUCCESS = "ACTIVATE_PERSONAL_REQ_SUCCESS";
export const ACTIVATE_PERSONAL_REQ_FAILURE = "ACTIVATE_PERSONAL_REQ_FAILURE";
export const PROMPT_MOBILE_PHONE_INPUT = "PROMPT_MOBILE_PHONE_INPUT";
export const PROMPT_MOBILE_PHONE_INPUT_SUCCESS =
  "PROMPT_MOBILE_PHONE_INPUT_SUCCESS";
export const PROMPT_MOBILE_PHONE_INPUT_FAILURE =
  "PROMPT_MOBILE_PHONE_INPUT_FAILURE";
export const UPDATE_CLIENT_INFO = "UPDATE_CLIENT_INFO";
export const UPDATE_CLIENT_INFO_SUCCESS = "UPDATE_CLIENT_INFO_SUCCESS";
export const UPDATE_CLIENT_INFO_FAILURE = "UPDATE_CLIENT_INFO_FAILURE";
export const REGISTRATION_OTP_RESEND = "REGISTRATION_OTP_RESEND";
export const REGISTRATION_OTP_RESEND_SUCCESS = "REGISTRATION_OTP_RESEND_SUCCESS";
export const REGISTRATION_OTP_RESEND_FAILURE = "REGISTRATION_OTP_RESEND_FAILURE";

export const VALIDATE_MOVIE_REG = "VALIDATE_MOVIE_REG";
export const VALIDATE_MOVIE_REG_SUCCESS = "VALIDATE_MOVIE_REG_SUCCESS";
export const VALIDATE_MOVIE_REG_FAILURE = "VALIDATE_MOVIE_REG_FAILURE";
export const SUBMIT_MOVIE_REG = "SUBMIT_MOVIE_REG";
export const SUBMIT_MOVIE_REG_SUCCESS = "SUBMIT_MOVIE_REG_SUCCESS";
export const SUBMIT_MOVIE_REG_FAILURE = "SUBMIT_MOVIE_REG_FAILURE";

export const SUBMIT_CAMPAIGN_FORM_REQ = "SUBMIT_CAMPAIGN_FORM_REQ";
export const SUBMIT_CAMPAIGN_FORM_REQ_SUCCESS = "SUBMIT_CAMPAIGN_FORM_REQ_SUCCESS";
export const SUBMIT_CAMPAIGN_FORM_REQ_FAILURE = "SUBMIT_CAMPAIGN_FORM_REQ_FAILURE";
export const CALCULATE_WALKWAG_AMOUNT_REQ = "CALCULATE_WALKWAG_AMOUNT_REQ";
export const CALCULATE_WALKWAG_AMOUNT_REQ_SUCCESS = "CALCULATE_WALKWAG_AMOUNT_REQ_SUCCESS";
export const CALCULATE_WALKWAG_AMOUNT_REQ_FAILURE = "CALCULATE_WALKWAG_AMOUNT_REQ_FAILURE";
export const CHECK_PAYNOW_QR_STATUS_REQ = "CHECK_PAYNOW_QR_STATUS_REQ";
export const CHECK_PAYNOW_QR_STATUS_REQ_SUCCESS = "CHECK_PAYNOW_QR_STATUS_REQ_SUCCESS";
export const CHECK_PAYNOW_QR_STATUS_REQ_FAILURE = "CHECK_PAYNOW_QR_STATUS_REQ_FAILURE";

export const GET_REGISTRATION_CUSTOMER_DETAILS = "GET_REGISTRATION_CUSTOMER_DETAILS";
export const GET_REGISTRATION_CUSTOMER_DETAILS_SUCCESS = "GET_REGISTRATION_CUSTOMER_DETAILS_SUCCESS";
export const GET_REGISTRATION_CUSTOMER_DETAILS_FAILURE = "GET_REGISTRATION_CUSTOMER_DETAILS_FAILURE";

export const REGISTER_CUSTOMER = "REGISTER_CUSTOMER";
export const REGISTER_CUSTOMER_SUCCESS = "REGISTER_CUSTOMER_SUCCESS";
export const REGISTER_CUSTOMER_FAILURE = "REGISTER_CUSTOMER_FAILURE";

export const GET_REGISTRATION_CUSTOMER_INFO = "GET_REGISTRATION_CUSTOMER_INFO";
export const GET_REGISTRATION_CUSTOMER_INFO_SUCCESS = "GET_REGISTRATION_CUSTOMER_INFO_SUCCESS";
export const GET_REGISTRATION_CUSTOMER_INFO_FAILURE = "GET_REGISTRATION_CUSTOMER_INFO_FAILURE";

export const GET_LOGIN_TOKEN = "GET_LOGIN_TOKEN";
export const GET_LOGIN_TOKEN_SUCCESS = "GET_LOGIN_TOKEN_SUCCESS";
export const GET_LOGIN_TOKEN_FAILURE = "GET_LOGIN_TOKEN_FAILURE";

export const GENERATE_OTP_ONBOARDING = "GENERATE_OTP_ONBOARDING";
export const GENERATE_OTP_ONBOARDING_SUCCESS = "GENERATE_OTP_ONBOARDING_SUCCESS";
export const GENERATE_OTP_ONBOARDING_FAILURE = "GENERATE_OTP_ONBOARDING_FAILURE";

export const REGISTER_NEW_CUSTOMERV2 = "REGISTER_NEW_CUSTOMERV2";
export const REGISTER_NEW_CUSTOMERV2_SUCCESS = "REGISTER_NEW_CUSTOMERV2_SUCCESS";
export const REGISTER_NEW_CUSTOMERV2_FAILURE = "REGISTER_NEW_CUSTOMERV2_FAILURE";

export const LOG_REGISTRATION_REQUEST = "LOG_REGISTRATION_REQUEST";
export const LOG_REGISTRATION_REQUEST_SUCCESS = "LOG_REGISTRATION_REQUEST_SUCCESS";
export const LOG_REGISTRATION_REQUEST_FAILURE = "LOG_REGISTRATION_REQUEST_FAILURE";

export const VALIDATION_REGISTRATION = "VALIDATION_REGISTRATION";
export const VALIDATION_REGISTRATION_SUCCESS = "VALIDATION_REGISTRATION_SUCCESS";
export const VALIDATION_REGISTRATION_FAILURE = "VALIDATION_REGISTRATION_FAILURE";

export const UPLOAD_OCR_NRIC = "UPLOAD_OCR_NRIC";
export const UPLOAD_OCR_NRIC_SUCCESS = "UPLOAD_OCR_NRIC_SUCCESS";
export const UPLOAD_OCR_NRIC_FAILURE = "UPLOAD_OCR_NRIC_FAILURE";

export const UPDATE_CLIENT_INFOV4_REQUEST = "UPDATE_CLIENT_INFOV4_REQUEST";
export const UPDATE_CLIENT_INFOV4_REQUEST_SUCCESS = "UPDATE_CLIENT_INFOV4_REQUEST_SUCCESS";
export const UPDATE_CLIENT_INFOV4_REQUEST_FAILURE = "UPDATE_CLIENT_INFOV4_REQUEST_FAILURE";

export const RESET_REG = "RESET_REG";

//Registration
export const registrationRequest = (nric, recaptchaToken) => ({
  type: "REGISTRATION_REQUEST",
  nric,
  recaptchaToken
});

export const registrationSuccess = (data) => ({
  type: "REGISTRATION_SUCCESS",
  data,
});

export const registrationFailure = (message) => ({
  type: "REGISTRATION_FAILURE",
  message,
});

//Registration Otp Send
export const registrationOtpRequest = (nric) => ({
  type: "REGISTRATION_OTP_REQUEST",
  nric,
});

export const registrationOtpSuccess = (data) => ({
  type: "REGISTRATION_OTP_SUCCESS",
  data,
});

export const registrationOtpFailure = (message) => ({
  type: "REGISTRATION_OTP_FAILURE",
  message,
});

//Registration Otp Verify
export const registrationOtpVerify = (
  nric,
  otpReference,
  c2facode,
  mobileNo,
  mobileCountryCode
) => ({
  type: "REGISTRATION_OTP_VERIFY",
  nric,
  otpReference,
  c2facode,
  mobileNo,
  mobileCountryCode,
});

export const registrationOtpVerifySuccess = (data) => ({
  type: "REGISTRATION_OTP_VERIFY_SUCCESS",
  data,
});

export const registrationOtpVerifyFailure = (message) => ({
  type: "REGISTRATION_OTP_VERIFY_FAILURE",
  message,
});

//Activation Generic Link
export const activationGenericLinkRequest = (
  userID,
  password,
  confirmPassword,
  nric,
  dob
) => ({
  type: "ACTIVATION_GENERIC_LINK_REQUEST",
  userID,
  password,
  confirmPassword,
  nric,
  dob,
});

export const activationGenericLinkSuccess = (data) => ({
  type: "ACTIVATION_GENERIC_LINK_SUCCESS",
  data,
});

export const activationGenericLinkFailure = (message) => ({
  type: "ACTIVATION_GENERIC_LINK_FAILURE",
  message,
});

//Activation Generic Link OTP verify
export const activationGenericOTPVerifyReq = (
  nric,
  otpReferenceNo,
  code,
  password,
  userID
) => ({
  type: "ACTIVATION_GENERIC_OTP_VERIFY_REQ",
  nric,
  otpReferenceNo,
  code,
  password,
  userID,
});

export const activationGenericOTPVerifySuccess = (data) => ({
  type: "ACTIVATION_GENERIC_OTP_VERIFY_SUCCESS",
  data,
});

export const activationGenericOTPVerifyFailure = (message) => ({
  type: "ACTIVATION_GENERIC_OTP_VERIFY_FAILURE",
  message,
});

//Activation Personal Link Req
export const activationPersonalLinkReq = (q, a, r) => ({
  type: "ACTIVATION_PERSONAL_LINK_REQ",
  q,
  a,
  r,
});

export const activationPersonalLinkReqSuccess = (data) => ({
  type: "ACTIVATION_PERSONAL_LINK_REQ_SUCCESS",
  data,
});

export const activationPersonalLinkReqFailure = (message) => ({
  type: "ACTIVATION_PERSONAL_LINK_REQ_FAILURE",
  message,
});

//Activate Personal Link
export const activatePersonalReq = (
  nric,
  userID,
  password,
  confirmPassword,
  nricFromLink
) => ({
  type: "ACTIVATE_PERSONAL_REQ",
  nric,
  userID,
  password,
  confirmPassword,
  nricFromLink,
});

export const activatePersonalReqSuccess = (data) => ({
  type: "ACTIVATE_PERSONAL_REQ_SUCCESS",
  data,
});

export const activatePersonalReqFailure = (message) => ({
  type: "ACTIVATE_PERSONAL_REQ_FAILURE",
  message,
});

//Prompt Mobile Phone Input
export const promptMobilePhoneInput = (nric, mobileNo, mobileCountryCode, recaptchaToken) => ({
  type: "PROMPT_MOBILE_PHONE_INPUT",
  nric,
  mobileNo,
  mobileCountryCode,
  recaptchaToken
});

export const promptMobilePhoneInputSuccess = (data) => ({
  type: "PROMPT_MOBILE_PHONE_INPUT_SUCCESS",
  data,
});

export const promptMobilePhoneInputFailure = (message) => ({
  type: "PROMPT_MOBILE_PHONE_INPUT_FAILURE",
  message,
});

//Update Client Info
export const updateClientInfo = (
  nric,
  userId,
  password,
  email,
  dateOfBirth,
  name,
) => ({
  type: "UPDATE_CLIENT_INFO",
  nric,
  userId,
  password,
  email,
  dateOfBirth,
  name,
});

export const updateClientInfoSuccess = (data) => ({
  type: "UPDATE_CLIENT_INFO_SUCCESS",
  data,
});

export const updateClientInfoFailure = (message) => ({
  type: "UPDATE_CLIENT_INFO_FAILURE",
  message,
});

//Registration Resend Otp 
export const registrationOtpResend = (nric) => ({
  type: "REGISTRATION_OTP_RESEND",
  nric,
});

export const registrationOtpResendSuccess = (data) => ({
  type: "REGISTRATION_OTP_RESEND_SUCCESS",
  data,
});

export const registrationOtpResendFailure = (message) => ({
  type: "REGISTRATION_OTP_RESEND_FAILURE",
  message,
});

//Validate Movie Reg
export const validateMovieReg = (nric, dob) => ({
  type: "VALIDATE_MOVIE_REG",
  nric, dob
});

export const validateMovieRegSuccess = (data) => ({
  type: "VALIDATE_MOVIE_REG_SUCCESS",
  data,
});

export const validateMovieRegFailure = (message) => ({
  type: "VALIDATE_MOVIE_REG_FAILURE",
  message,
});

//Submit Movie Reg
export const submitMovieReg = (otp, otpReference) => ({
  type: "SUBMIT_MOVIE_REG",
  otp, otpReference
});

export const submitMovieRegSuccess = (data) => ({
  type: "SUBMIT_MOVIE_REG_SUCCESS",
  data,
});

export const submitMovieRegFailure = (message) => ({
  type: "SUBMIT_MOVIE_REG_FAILURE",
  message,
});

//submitCampaignFormReq
export const submitCampaignFormReq = (bodyData) => ({
  type: "SUBMIT_CAMPAIGN_FORM_REQ",
  bodyData,
});
export const submitCampaignFormReqSuccess = (data) => ({
  type: "SUBMIT_CAMPAIGN_FORM_REQ_SUCCESS",
  data,
});
export const submitCampaignFormReqFailure = (message) => ({
  type: "SUBMIT_CAMPAIGN_FORM_REQ_FAILURE",
  message,
});

//calculateWalkWagAmount
export const calculateWalkWagAmountReq = (bodyData) => ({
  type: "CALCULATE_WALKWAG_AMOUNT_REQ",
  bodyData,
});
export const calculateWalkWagAmountReqSuccess = (data) => ({
  type: "CALCULATE_WALKWAG_AMOUNT_REQ_SUCCESS",
  data,
});
export const calculateWalkWagAmountReqFailure = (message) => ({
  type: "CALCULATE_WALKWAG_AMOUNT_REQ_FAILURE",
  message,
});

//checkPayNowQRStatus
export const checkPayNowQRStatusReq = (bodyData) => ({
  type: "CHECK_PAYNOW_QR_STATUS_REQ",
  bodyData,
});
export const checkPayNowQRStatusReqSuccess = (data) => ({
  type: "CHECK_PAYNOW_QR_STATUS_REQ_SUCCESS",
  data,
});
export const checkPayNowQRStatusReqFailure = (message) => ({
  type: "CHECK_PAYNOW_QR_STATUS_REQ_FAILURE",
  message,
});


export const getRegistrationCustomerDetails = (bodyData) => ({
  type: "GET_REGISTRATION_CUSTOMER_DETAILS",
  bodyData,
});
export const getRegistrationCustomerDetailsSuccess = (data) => ({
  type: "GET_REGISTRATION_CUSTOMER_DETAILS_SUCCESS",
  data,
});
export const getRegistrationCustomerDetailsFailure = (message) => ({
  type: "GET_REGISTRATION_CUSTOMER_DETAILS_FAILURE",
  message,
});

export const registerNewCustomer = (bodyData) => ({
  type: "REGISTER_CUSTOMER",
  bodyData,
});
export const registerNewCustomerSuccess = (data) => ({
  type: "REGISTER_CUSTOMER_SUCCESS",
  data,
});
export const registerNewCustomerFailure = (message) => ({
  type: "REGISTER_CUSTOMER_FAILURE",
  message,
});

//revamp 2.0
export const getRegistrationCustomerInfo = (bodyData) => ({
  type: "GET_REGISTRATION_CUSTOMER_INFO",
  bodyData,
});
export const getRegistrationCustomerInfoSuccess = (data) => ({
  type: "GET_REGISTRATION_CUSTOMER_INFO_SUCCESS",
  data,
});
export const getRegistrationCustomerInfoFailure = (message) => ({
  type: "GET_REGISTRATION_CUSTOMER_INFO_FAILURE",
  message,
});

export const getLoginToken = (bodyData) => ({
  type: "GET_LOGIN_TOKEN",
  bodyData,
});
export const getLoginTokenSuccess = (data) => ({
  type: "GET_LOGIN_TOKEN_SUCCESS",
  data,
});
export const getLoginTokenFailure = (message) => ({
  type: "GET_LOGIN_TOKEN_FAILURE",
  message,
});

export const generateOTPOnboarding = (bodyData) => ({
  type: "GENERATE_OTP_ONBOARDING",
  bodyData,
});
export const generateOTPOnboardingSuccess = (data) => ({
  type: "GENERATE_OTP_ONBOARDING_SUCCESS",
  data,
});
export const generateOTPOnboardingFailure = (message) => ({
  type: "GENERATE_OTP_ONBOARDING_FAILURE",
  message,
});

export const registerNewCustomerv2 = (bodyData) => ({
  type: "REGISTER_NEW_CUSTOMERV2",
  bodyData,
});
export const registerNewCustomerv2Success = (data) => ({
  type: "REGISTER_NEW_CUSTOMERV2_SUCCESS",
  data,
});
export const registerNewCustomerv2Failure = (message) => ({
  type: "REGISTER_NEW_CUSTOMERV2_FAILURE",
  message,
});

export const logRegistrationRequest = (bodyData) => ({
  type: "LOG_REGISTRATION_REQUEST",
  bodyData,
});
export const logRegistrationRequestSuccess = (data) => ({
  type: "LOG_REGISTRATION_REQUEST_SUCCESS",
  data,
});
export const logRegistrationRequestFailure = (message) => ({
  type: "LOG_REGISTRATION_REQUEST_FAILURE",
  message,
});

export const validateRegistration = (bodyData) => ({
  type: "VALIDATION_REGISTRATION",
  bodyData,
});
export const validateRegistrationSuccess = (data) => ({
  type: "VALIDATION_REGISTRATION_SUCCESS",
  data,
});
export const validateRegistrationFailure = (message) => ({
  type: "VALIDATION_REGISTRATION_FAILURE",
  message,
});

export const uploadOcrNric = (bodyData) => ({
  type: "UPLOAD_OCR_NRIC",
  bodyData,
});
export const uploadOcrNricSuccess = (data) => ({
  type: "UPLOAD_OCR_NRIC_SUCCESS",
  data,
});
export const uploadOcrNricFailure = (message) => ({
  type: "UPLOAD_OCR_NRIC_FAILURE",
  message,
});

export const updateClientInfov4Request = (bodyData) => ({
  type: "UPDATE_CLIENT_INFOV4_REQUEST",
  bodyData,
});
export const updateClientInfov4Success = (data) => ({
  type: "UPDATE_CLIENT_INFOV4_REQUEST_SUCCESS",
  data,
});
export const updateClientInfov4Failure = (message) => ({
  type: "UPDATE_CLIENT_INFOV4_REQUEST_FAILURE",
  message,
});
//Reset OTP Action
export const resetRegAction = search => {
  return {
    type: "RESET_REG"
  };
};


